import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Quay} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
  selector: 'app-edit-quay',
  templateUrl: './edit-quay.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EditQuayComponent implements OnInit {
  @Input() quay: Quay;
  positionValues: string[] = [];


  ngOnInit(): void {
    this.positionValues = this.quay?.positions ? Object.keys(this.quay.positions).sort() : [];
  }
}
